import React, { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "../Button";

// import { filterMulti, filterText } from "../../utils";
import "./Search.scss";

export const Search = ({
  onChange = () => {},
  placeholder = "",
  title = "",
  className = "",
  value = "",
}) => {
  const searchRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState(value);

  useEffect(() => {
    setSearchTerm(value);
  }, [value]);

  const search = useCallback(() => {
    onChange(searchTerm);
  }, [onChange, searchTerm]);

  const onFormSubmit = useCallback(
    (e) => {
      e.preventDefault();
      search();
      return false;
    },
    [search]
  );

  const broadcastChange = useCallback((e) => {
    setSearchTerm(e.target.value.toString());
  }, []);

  return (
    <div
      style={{ width: `100% !important` }}
      className={`search-bar__container flex flex-column col-12 ${className}`}
    >
      <div>{title}</div>
      <form onSubmit={onFormSubmit} className="relative">
        <input
          value={searchTerm}
          className="bg-transparent block-font color-secondary col-12 pb1 h4"
          placeholder={placeholder}
          ref={searchRef}
          onChange={broadcastChange}
        />
        <div className="absolute right-0 bottom-0 flex flex-row mb1">
          <Button
            onClick={search}
            className="rounded block-font uppercase p0 h6"
          >
            Search
          </Button>
        </div>
      </form>
    </div>
  );
};
